import React from "react";

const DeleteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
    >
      <path
        d="M1 5.44434H19"
        stroke="#3F3F3F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.25 8.77734L5.16409 19.175C5.35861 20.2317 6.2904 20.9997 7.37779 20.9997H12.6222C13.7096 20.9997 14.6414 20.2316 14.8359 19.175L16.75 8.77734"
        stroke="#3F3F3F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.625 3.22225C6.625 1.99494 7.63236 1 8.875 1H11.125C12.3677 1 13.375 1.99494 13.375 3.22225V5.44451H6.625V3.22225Z"
        stroke="#3F3F3F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DeleteIcon;
